import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Listbox, Transition, Switch } from "@headlessui/react";
import { Toaster, ToastIcon, toast, resolveValue } from "react-hot-toast";
import SubmitModalCustomer from "../components/SubmitModalCustomer";
import SubmitModal from "../components/SubmitModal";
import { createService } from "../api/customerRequest";
import { createTicket } from "../api/zoho";
import {
  fetchCity,
  fetchSuburb,
  fetchDeviceType,
  fetchTechnical,
  fetchAccountType,
} from "../api/dropdown";
import { fetchCustomer } from "../api/customerRequest";
import CustomerERPModel from "../components/CustomerERPModel";
import { useDropdown } from "../store/dropdown-context";

const schema = yup.object().shape({
  status: yup.string(),
  serviceRequestType: yup.string().nullable().required("يرجى تعبئة الخانة"),
  accountCode: yup.string(),
  accountCodeERP: yup.string().notRequired(),
  accountType: yup.string().nullable().required("يرجى تعبئة الخانة"),
  requestType: yup.string().nullable().required("يرجى تعبئة الخانة"),
  clientName: yup.string().required().required("يرجى تعبئة الخانة"),
  phone: yup.string().required("يرجى تعبئة الخانة"),
  city: yup.string().nullable().required("يرجى تعبئة الخانة"),
  suburb: yup.string().nullable().required("يرجى تعبئة الخانة"),
  cf_nw_aljhaz: yup.string().nullable().required("يرجى تعبئة الخانة"),
  quantity: yup.string().nullable().required("يرجى تعبئة الخانة"),
  technical: yup
    .object()
    .shape({
      name: yup.string(),
      phone1: yup.string().notRequired().nullable(),
      phone2: yup.string().notRequired().nullable(),
    })
    .nullable()
    .notRequired(),
  cf_nw_alwasf: yup.string().notRequired().nullable(),
  notes: yup.string().notRequired().nullable(),
  notes2: yup.string().notRequired().nullable(),
  notes3: yup.string().notRequired().nullable(),
  cf_nw_rmzAljhaz: yup
    .object()
    .required("يرجى تعبئة الخانة")
    .shape({
      deviceId: yup.number().required("يرجى تعبئة الخانة"),
      description: yup.string().required("يرجى تعبئة الخانة"),
      name: yup.string().required("يرجى تعبئة الخانة"),
    }),
  agentName: yup.string(),
});

const TailwindToaster = () => {
  return (
    <Toaster>
      {(t) => (
        <Transition
          appear
          show={t.visible}
          className="transform p-4 flex bg-white rounded shadow-lg"
          enter="transition-all duration-150"
          enterFrom="opacity-0 scale-50"
          enterTo="opacity-100 scale-100"
          leave="transition-all duration-150"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-75"
        >
          <ToastIcon toast={t} />
          <p className="px-2">{resolveValue(t.message)}</p>
        </Transition>
      )}
    </Toaster>
  );
};

const people = ["منشأ", "تحت العمل", "منتهي", "ملغي"];
let citys = [
  { id: 2, name: "مصراتة" },
  { id: 3, name: "بنغازي" },
];
let suburbs = [
  { id: 1, name: "11يونيو" },
  { id: 2, name: "الحي الاسلامي" },
  { id: 3, name: "السبعة" },
];

let serviceRequestTypes = ["صيانة", "تركيب", "كشف"];
// let technicals = [{ name: 'وليد العريبي', phone1: '0915109263', phone2: null }];
let technicals = [{ name: "لا يوجد", phone1: null, phone2: null }];
let cf_nw_alwasfs = ["صيانة خارجية", "تركيب", ""];
let accountTypes = [{ id: 1, name: "SRV" }];
let deviceCodesx = [
  {
    deviceId: 1,
    description: "مكيف هومر 9",
    name: "001.009.001.004",
  },
  {
    deviceId: 2,
    description: "مكيف هومر فيري -HS-12F/CH-12",
    name: "001.012.001.006",
  },
];
let deviceTypes = [{ name: "أخرى", id: 39, deviceCodes: [] }];
const ServiceRequestFormScreen = () => {
  const {
    citysContext,
    accountTypeContext,
    technicalContext,
    deviceTypeContext,
    complaintValidityContext,
    agentNameContext,
  } = useDropdown();
  let { phoneNumber } = useParams();
  let navigate = useNavigate();
  const location = useLocation();
  const [xx, setxx] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [source, setSource] = useState("");

  const [open, setOpen] = useState(false);
  const [reload, setReload] = useState(false);
  const [customerERPModel, setCustomerERPModel] = useState(false);
  const [error, setError] = useState("");
  const [number, setNumber] = useState("");
  const [selectedPerson, setSelectedPerson] = useState(people[0] || []);
  const [selectedCity, setSelectedCity] = useState(
    citys?.length > 0
      ? citys[0]
      : {
          id: 0,
          name: "",
        }
  );
  const [selectedSuburb, setSelectedSuburb] = useState(suburbs[0] || []);
  const [openCustomer, setOpenCustomer] = useState(false);
  const [selectedDeviceType, setSelectedDeviceType] = useState(
    deviceTypes[0] || []
  );
  const [selectedServiceRequestType, setSelectedServiceRequestType] = useState(
    serviceRequestTypes[2]
  );
  const [selectedTechnical, setSelectedTechnical] = useState(
    technicals?.length > 0
      ? technicals[0]
      : { name: "لا يوجد", phone1: null, phone2: null }
  );
  const [selectedCf_nw_alwasf, setSelectedCf_nw_alwasf] = useState(
    selectedServiceRequestType === "صيانة"
      ? cf_nw_alwasfs[0]
      : selectedServiceRequestType === "تركيب"
      ? cf_nw_alwasfs[1]
      : cf_nw_alwasfs[2]
  );

  const [done, setDone] = useState(false);
  const [doneTic, setDoneTic] = useState(false);
  const [loadding, setLoadding] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [customerERP, setCustomerERP] = useState();
  const [selectedAccountType, setSelectedAccountType] = useState(
    accountTypes?.length > 0
      ? accountTypes[0]?.name
      : { id: 1, name: "SRV" }?.name
  );
  const [selectedDeviceCode, setSelectedDeviceCode] = useState(deviceCodesx[0]);

  const onSubmit = (data, e) => {
    e.preventDefault();
    console.log("data.agentName data.agentName data.agentName", data.agentName);
    let x = data;
    x.source = source;
    setDisableSubmit(true);
    if (
      agentNameContext.length > 0 &&
      agentNameContext != undefined &&
      agentNameContext != null &&
      agentNameContext != ""
    ) {
      setValue("agentName", agentNameContext, {
        shouldValidate: true,
      });
      x.agentName = agentNameContext;
      console.log("agentNameContext on submit", agentNameContext);
    } else {
      let agentName = localStorage.getItem("agentName");
      setValue("agentName", agentName, {
        shouldValidate: false,
      });
      x.agentName = agentName;

      console.log("agentName on submit", agentName);
    }
    setValue("serviceRequestType", selectedServiceRequestType, {
      shouldValidate: true,
    });
    setValue("accountCodeERP", customerERP?.accountCode, {
      shouldValidate: true,
    });
    setValue("cf_nw_alwasf", selectedCf_nw_alwasf, {
      shouldValidate: true,
    });
    setValue("technical", selectedTechnical, {
      shouldValidate: true,
    });
    setValue("city", selectedCity?.name, {
      shouldValidate: true,
    });
    setValue("suburb", selectedSuburb?.name, {
      shouldValidate: true,
    });
    setValue("status", selectedPerson, {
      shouldValidate: true,
    });
    setValue("accountType", selectedAccountType, {
      shouldValidate: true,
    });
    setValue("cf_nw_rmzAljhaz", selectedDeviceCode, {
      shouldValidate: true,
    });
    toast.loading("جاري ارسال طلب الخدمة");
    console.log(data, "data");
    if (selectedServiceRequestType !== "كشف") {
      createTicket(x)
        .then((data) => {
          toast.dismiss();
          if (data.success === true) {
            toast.success("تم ارسال طلب الخدمة بنجاح");
            setTimeout(() => {
              navigate(`/${phoneNumber}`);
              setDisableSubmit(false);
            }, 2000);
          } else {
            toast.error(data.error);
            setDisableSubmit(false);
          }
        })
        .catch((err) => {
          toast.dismiss();

          toast.error(data.error);
          setDisableSubmit(false);
        });
    } else {
      createTicket(x)
        .then((data) => {
          toast.dismiss();

          if (data.success === true) {
            toast.success("تم ارسال طلب الخدمة بنجاح");
            setTimeout(() => {
              navigate(`/${phoneNumber}`);
              setDisableSubmit(false);
            }, 2000);
          } else {
            toast.error("حدث خطأ ما");
            setDisableSubmit(false);
          }
        })
        .catch((err) => {
          toast.dismiss();

          toast.error("حدث خطأ ما");
          setDisableSubmit(false);
        });
    }
  };

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (selectedServiceRequestType !== "كشف") {
      toast.promise(
        fetchCustomer(phoneNumber)
          .then((data) => {
            if (data.data.success === true) {
              if (data?.data?.data?.length > 0) {
                toast.success("تم تحميل البيانات بنجاح");
                if (data.data.data.length == 1) {
                  setCustomers((prevState) => [data.data.data[0]]);
                } else if (data.data.data.length == 2) {
                  setCustomers((prevState) => [
                    data.data.data[0],
                    data.data.data[1],
                  ]);
                }
              } else {
                toast.error("لا يوجد بيانات لعرضها");
                setCustomerERPModel(false);
              }
            } else {
              toast.error("حدث خطأ ما");
              setCustomerERPModel(false);
            }
          })
          .catch((err) => {
            toast.error("لا يوجد بيانات لعرضها");
            setCustomerERPModel(false);
          })
          .finally(() => {
            setLoadding(false);
          }),
        {
          loading: "Loading...",
          success: "Success",
          error: (err) => err.response.data.msg,
        }
      );
    }
  }, [phoneNumber, selectedServiceRequestType]);

  useEffect(() => {
    try { 
      citys = citysContext;
      accountTypes = accountTypeContext;

      technicals = technicalContext;
      technicals.unshift({ name: "لا يوجد", phone1: null, phone2: null });

      deviceTypes = deviceTypeContext;
      setSelectedDeviceType(deviceTypes[0]);
      deviceCodesx = deviceTypes[1]?.deviceCodes;
      if (deviceCodesx?.length > 0) {
        setSelectedDeviceCode(deviceCodesx[0]);
      }
      if (
        agentNameContext.length > 0 &&
        agentNameContext != undefined &&
        agentNameContext != null &&
        agentNameContext != ""
      ) {
        setValue("agentName", agentNameContext, {
          shouldValidate: true,
        });
      } else {
        let agentName = localStorage.getItem("agentName");
        setValue("agentName", agentName, {
          shouldValidate: true,
        });
      }
      if (location.state) {

        setSource(location.state.account.source);
        setValue("accountCode", location.state.account.accountCode, {
          shouldValidate: true,
        });
        setValue("phone", location.state.account.phone, {
          shouldValidate: true,
        });
        setNumber(location?.state?.account?.phone || phoneNumber);
        // setValue('accountType', location.state.account.accountType, {
        //   shouldValidate: true,
        // });
        setValue("clientName", location.state.account.clientName, {
          shouldValidate: true,
        });
        setSelectedCity(
          citys.find(
            (element) => element?.name === location?.state?.account?.city
          )
        );
        setxx(location?.state?.account?.suburb);
        setSelectedAccountType(location.state.account.accountType);
        if (
          agentNameContext.length > 0 &&
          agentNameContext != undefined &&
          agentNameContext != null &&
          agentNameContext != ""
        ) {
          setValue("agentName", agentNameContext, {
            shouldValidate: true,
          });
          console.log(agentNameContext, "1");
        } else {
          let agentName = localStorage.getItem("agentName");
          setValue("agentName", agentName, {
            shouldValidate: true,
          });
          console.log(agentName, "2");
        }
      }

      // setLoadding(false);
    } catch (error) {
      console.log(error);
      setError(error.message);
    }
  }, [location.state, phoneNumber, setValue, citysContext]);

  useEffect(() => {
    // setLoadding(true);
    // setError('');
    window.scrollTo(0, 0);

    try {
      if (location.state) {
        setSource(location.state.account.source);
        setValue("accountCode", location.state.account.accountCode, {
          shouldValidate: true,
        });
        setValue("phone", location.state.account.phone, {
          shouldValidate: true,
        });
        // setValue('accountType', location.state.account.accountType, {
        //   shouldValidate: true,
        // });
        setValue("notes", location.state.account.notes, {
          shouldValidate: true,
        });
        setValue("notes2", location.state.account.notes2, {
          shouldValidate: true,
        });
        setValue("notes3", location.state.account.notes3, {
          shouldValidate: true,
        });
        setValue("requestType", location.state.account.requestType, {
          shouldValidate: true,
        });
        setValue("clientName", location.state.account.clientName, {
          shouldValidate: true,
        });
        setValue("agentName", agentNameContext, {
          shouldValidate: true,
        });
      }
      // setLoadding(false);
    } catch (error) {
      // setError(error.message);
    }
  }, [location.state, setValue]);

  useEffect(() => {
    setValue("city", selectedCity?.name, {
      shouldValidate: true,
    });
    setValue("suburb", selectedSuburb?.name, {
      shouldValidate: true,
    });
    setValue("cf_nw_aljhaz", selectedDeviceType.name, {
      shouldValidate: true,
    });
    setValue("serviceRequestType", selectedServiceRequestType, {
      shouldValidate: true,
    });
    setValue("technical", selectedTechnical, {
      shouldValidate: true,
    });
    setValue("cf_nw_alwasf", selectedCf_nw_alwasf, {
      shouldValidate: true,
    });
    setValue("accountCodeERP", customerERP?.accountCode, {
      shouldValidate: true,
    });
    setValue("accountType", selectedAccountType, {
      shouldValidate: true,
    });
    setValue("cf_nw_rmzAljhaz", selectedDeviceCode, {
      shouldValidate: true,
    });
    setSelectedCf_nw_alwasf(
      selectedServiceRequestType === "صيانة"
        ? cf_nw_alwasfs[0]
        : selectedServiceRequestType === "تركيب"
        ? cf_nw_alwasfs[1]
        : cf_nw_alwasfs[2]
    );
  }, [
    selectedCity,
    selectedSuburb,
    selectedDeviceType,
    selectedServiceRequestType,
    selectedTechnical,
    selectedCf_nw_alwasf,
    customerERP,
    selectedAccountType,
    selectedDeviceCode,
    setValue,
  ]);

  useEffect(() => {
    if (selectedServiceRequestType !== "كشف") {
      setCustomerERPModel(true);
      setSelectedPerson("منشأ");
    }
  }, [selectedServiceRequestType]);

  useEffect(() => {
    deviceCodesx = selectedDeviceType?.deviceCodes;
    console.log(selectedDeviceType?.deviceCodes);
    setSelectedDeviceCode(deviceCodesx[0]);
  }, [selectedDeviceType]);
  useEffect(() => {
    if (xx?.length > 0 && selectedCity?.name !== xx) {
      setSelectedSuburb(
        selectedCity?.Suburbs.find((element) => element?.name === xx)
      );
      if (selectedCity?.Suburbs?.length > 0) {
        suburbs = selectedCity?.Suburbs;
        suburbs.sort(function (a, b) {
          return a.name.localeCompare(b.name, ["ar"]);
        });
      } else {
        suburbs = [selectedCity];
        setSelectedSuburb(suburbs[0]);
      }
    } else {
      if (selectedCity?.Suburbs?.length > 0) {
        suburbs = [selectedCity, ...selectedCity?.Suburbs];
        suburbs.sort(function (a, b) {
          return a.name.localeCompare(b.name, ["ar"]);
        });
        setSelectedSuburb(suburbs[0]);
      } else {
        suburbs = [selectedCity];
        suburbs.sort(function (a, b) {
          return a.name.localeCompare(b.name, ["ar"]);
        });
        setSelectedSuburb(suburbs[0]);
      }
    }
  }, [selectedCity]);
  function isEmpty(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) return false;
    }
    return true;
  }

  useEffect(() => {
    console.log(errors, "errors errors errors");
    if (!isEmpty(errors)) {
      toast.error("يرجى التحقق من الخانات");
    }
  }, [errors]);
  return (
    <div
      className="bg-background-100 h-full min-h-screen w-full flex flex-col px-20 py-20"
      dir="rtl"
    >
      {
        <SubmitModalCustomer
          open={open}
          setOpen={setOpen}
          phoneNumber={number}
          setError={setError}
          setDone={setDone}
          technical={selectedTechnical}
        />
      }
      {
        <CustomerERPModel
          customerERPModel={customerERPModel}
          setCustomerERPModel={setCustomerERPModel}
          customers={customers}
          customerERP={customerERP}
          setCustomerERP={setCustomerERP}
        />
      }
      <div className="mx-auto ">
        <p className="text-title-100 text-xl font-bold">نموذج طلب خدمة</p>
      </div>

      {
        <SubmitModal
          openCustomer={openCustomer}
          setOpenCustomer={setOpenCustomer}
          phoneNumber={number}
          technical={selectedTechnical}
          setDone={setDoneTic}
          setError={setError}
          setReload={setReload}
          selectedCity={selectedCity?.name}
          selectedSuburb={selectedSuburb?.name}
        />
      }
      <div className="pt-14 justify-between flex ">
        <p className="text-title-100 text-xl ">رقم الهاتف : {phoneNumber}</p>
        <div className="">
          <button
            type="button"
            onClick={() => navigate(`/CalLlogsScreen/${phoneNumber}`)}
            className=" text-white bg-button-100 hover:bg-blue-800  rounded-md  font-medium  text-sm px-10 py-2  "
          >
            السجل
          </button>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-44">
        <div className="flex  pt-12">
          <div className="w-full  ">
            <Listbox
              as="div"
              className="space-y-1"
              value={selectedPerson}
              onChange={setSelectedPerson}
            >
              {({ open }) => (
                <>
                  <Listbox.Label className="block  leading-5 text-title-100 text-xl pb-4">
                    حالة النموذج
                  </Listbox.Label>
                  <div className="relative">
                    <span className="inline-block w-full rounded-md shadow-sm">
                      <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                        <span className="block truncate">{selectedPerson}</span>
                        <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                          <svg
                            className="h-5 w-5 text-gray-400"
                            viewBox="0 0 20 20"
                            fill="none"
                            stroke="currentColor"
                          >
                            <path
                              d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </Listbox.Button>
                    </span>
                    {selectedServiceRequestType == "كشف" && (
                      <Transition
                        show={open}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                        className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                      >
                        <Listbox.Options
                          static
                          className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                        >
                          {people.map((person) => (
                            <Listbox.Option key={person} value={person}>
                              {({ selected, active }) => (
                                <div
                                  className={`${
                                    active
                                      ? "text-white bg-blue-600"
                                      : "text-gray-900"
                                  } cursor-default select-none relative py-2 pl-8 pr-4`}
                                >
                                  <span
                                    className={`${
                                      selected ? "font-semibold" : "font-normal"
                                    } block truncate`}
                                  >
                                    {person}
                                  </span>
                                  {selected && (
                                    <span
                                      className={`${
                                        active ? "text-white" : "text-blue-600"
                                      } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                    >
                                      <svg
                                        className="h-5 w-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </span>
                                  )}
                                </div>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </Transition>
                    )}
                  </div>
                </>
              )}
            </Listbox>
          </div>
        </div>
        <div className="flex  pt-12">
          <div className="w-full  ">
            <Listbox
              as="div"
              className="space-y-1"
              value={selectedServiceRequestType}
              onChange={setSelectedServiceRequestType}
            >
              {({ open }) => (
                <>
                  <Listbox.Label className="block  leading-5 text-title-100 text-xl pb-4">
                    نوع طلب الخدمة
                  </Listbox.Label>
                  <div className="relative">
                    <span className="inline-block w-full rounded-md shadow-sm">
                      <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                        <span className="block truncate">
                          {selectedServiceRequestType}
                        </span>
                        <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                          <svg
                            className="h-5 w-5 text-gray-400"
                            viewBox="0 0 20 20"
                            fill="none"
                            stroke="currentColor"
                          >
                            <path
                              d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </Listbox.Button>
                    </span>

                    <Transition
                      show={open}
                      leave="transition ease-in duration-100"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                      className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                    >
                      <Listbox.Options
                        static
                        className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                      >
                        {serviceRequestTypes.map((person) => (
                          <Listbox.Option key={person} value={person}>
                            {({ selected, active }) => (
                              <div
                                className={`${
                                  active
                                    ? "text-white bg-blue-600"
                                    : "text-gray-900"
                                } cursor-default select-none relative py-2 pl-8 pr-4`}
                              >
                                <span
                                  className={`${
                                    selected ? "font-semibold" : "font-normal"
                                  } block truncate`}
                                >
                                  {person}
                                </span>
                                {selected && (
                                  <span
                                    className={`${
                                      active ? "text-white" : "text-blue-600"
                                    } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                  >
                                    <svg
                                      className="h-5 w-5"
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </span>
                                )}
                              </div>
                            )}
                          </Listbox.Option>
                        ))}
                      </Listbox.Options>
                    </Transition>
                  </div>
                </>
              )}
            </Listbox>
          </div>
        </div>
      </div>

      <div className="py-12">
        <p className="text-title-100 text-xl">بيانات العميل</p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col space-y-6 ">
          <div
            className={
              !!customerERP
                ? "grid grid-cols-3 gap-44"
                : "grid grid-cols-2 gap-44"
            }
          >
            <div>
              <label htmlFor="" className=" text-title-100 text-md block">
                <span className="px-1">رقم العميل</span>
              </label>
              <input
                name="accountCode"
                disabled
                {...register("accountCode")}
                type="accountCode"
                className="w-full p-2 border border-gray-300 rounded mt-1"
              />
              <p className=" opacity-50 text-s">
                {errors?.accountCode?.message}
              </p>
            </div>
            {!!customerERP && (
              <div>
                <label htmlFor="" className=" text-title-100 text-md block">
                  <span className="px-1">رقم العميل ERP</span>
                </label>
                <input
                  name="accountCodeERP"
                  disabled
                  {...register("accountCodeERP")}
                  type="accountCodeERP"
                  className="w-full p-2 border border-gray-300 rounded mt-1"
                />
                <p className=" opacity-50 text-s">
                  {errors?.accountCodeERP?.message}
                </p>
              </div>
            )}
            <div className="flex ">
              <div className="w-full  ">
                <Listbox
                  as="div"
                  className="space-y-1"
                  value={selectedAccountType}
                  onChange={setSelectedAccountType}
                >
                  {({ open }) => (
                    <>
                      <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                        نوع الحساب
                      </Listbox.Label>
                      <div className="relative">
                        <span className="inline-block w-full rounded-md shadow-sm">
                          <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                            <span className="block truncate">
                              {selectedAccountType}
                            </span>
                            <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                              <svg
                                className="h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="none"
                                stroke="currentColor"
                              >
                                <path
                                  d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </Listbox.Button>
                        </span>

                        <Transition
                          show={open}
                          leave="transition ease-in duration-100"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                          className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                        >
                          <Listbox.Options
                            static
                            className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                          >
                            {accountTypes?.map((city) => (
                              <Listbox.Option key={city.name} value={city.name}>
                                {({ selected, active }) => (
                                  <div
                                    className={`${
                                      active
                                        ? "text-white bg-blue-600"
                                        : "text-gray-900"
                                    } cursor-default select-none relative py-2 pl-8 pr-4`}
                                  >
                                    <span
                                      className={`${
                                        selected
                                          ? "font-semibold"
                                          : "font-normal"
                                      } block truncate`}
                                    >
                                      {city.name}
                                    </span>
                                    {selected && (
                                      <span
                                        className={`${
                                          active
                                            ? "text-white"
                                            : "text-blue-600"
                                        } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                      >
                                        <svg
                                          className="h-5 w-5"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition>
                      </div>
                    </>
                  )}
                </Listbox>
              </div>
            </div>{" "}
          </div>
          <div className="grid grid-cols-2 gap-44">
            <div>
              <label htmlFor="" className=" text-title-100 text-md block">
                <span className="px-1">الاسم</span>
              </label>
              <input
                name="clientName"
                {...register("clientName")}
                type="clientName"
                className="w-full p-2 border border-gray-300 rounded mt-1"
              />
              <p className=" opacity-50 text-s">
                {errors?.clientName?.message}
              </p>
            </div>
            <div>
              <label htmlFor="" className=" text-title-100 text-md block">
                <span className="px-1">رقم الهاتف</span>
              </label>
              <input
                name="phone"
                {...register("phone")}
                type="phone"
                className="w-full p-2 border border-gray-300 rounded mt-1"
              />
              <p className=" opacity-50 text-s">{errors?.phone?.message}</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-44">
            <div className="flex ">
              <div className="w-full  z-30">
                <Listbox
                  as="div"
                  className="space-y-1"
                  value={selectedCity}
                  onChange={setSelectedCity}
                >
                  {({ open }) => (
                    <>
                      <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                        المدينة
                      </Listbox.Label>
                      <div className="relative">
                        <span className="inline-block w-full rounded-md shadow-sm">
                          <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                            <span className="block truncate">
                              {selectedCity?.name}
                            </span>
                            <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                              <svg
                                className="h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="none"
                                stroke="currentColor"
                              >
                                <path
                                  d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </Listbox.Button>
                        </span>

                        <Transition
                          show={open}
                          leave="transition ease-in duration-100"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                          className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                        >
                          <Listbox.Options
                            static
                            className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                          >
                            {citys?.map((person) => (
                              <Listbox.Option key={person?.name} value={person}>
                                {({ selected, active }) => (
                                  <div
                                    className={`${
                                      active
                                        ? "text-white bg-blue-600"
                                        : "text-gray-900"
                                    } cursor-default select-none relative py-2 pl-8 pr-4`}
                                  >
                                    <span
                                      className={`${
                                        selected
                                          ? "font-semibold"
                                          : "font-normal"
                                      } block truncate`}
                                    >
                                      {person?.name}
                                    </span>
                                    {selected && (
                                      <span
                                        className={`${
                                          active
                                            ? "text-white"
                                            : "text-blue-600"
                                        } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                      >
                                        <svg
                                          className="h-5 w-5"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition>
                      </div>
                    </>
                  )}
                </Listbox>
              </div>
            </div>{" "}
            <div className="flex  ">
              <div className="w-full  z-30">
                <Listbox
                  as="div"
                  className="space-y-1"
                  value={selectedSuburb}
                  onChange={setSelectedSuburb}
                >
                  {({ open }) => (
                    <>
                      <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                        الضاحية
                      </Listbox.Label>
                      <div className="relative">
                        <span className="inline-block w-full rounded-md shadow-sm">
                          <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                            <span className="block truncate">
                              {selectedSuburb?.name}
                            </span>
                            <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                              <svg
                                className="h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="none"
                                stroke="currentColor"
                              >
                                <path
                                  d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </Listbox.Button>
                        </span>

                        <Transition
                          show={open}
                          leave="transition ease-in duration-100"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                          className=" absolute mt-1 w-full rounded-md bg-white shadow-lg"
                        >
                          <Listbox.Options
                            static
                            className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                          >
                            {suburbs?.map((person) => (
                              <Listbox.Option key={person?.name} value={person}>
                                {({ selected, active }) => (
                                  <div
                                    className={`${
                                      active
                                        ? "text-white bg-blue-600"
                                        : "text-gray-900"
                                    } cursor-default select-none relative py-2 pl-8 pr-4`}
                                  >
                                    <span
                                      className={`${
                                        selected
                                          ? "font-semibold"
                                          : "font-normal"
                                      } block truncate`}
                                    >
                                      {person?.name}
                                    </span>
                                    {selected && (
                                      <span
                                        className={`${
                                          active
                                            ? "text-white"
                                            : "text-blue-600"
                                        } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                      >
                                        <svg
                                          className="h-5 w-5"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition>
                      </div>
                    </>
                  )}
                </Listbox>
              </div>
            </div>
          </div>

          <div className="py-8">
            <p className="text-title-100 text-xl">بيانات الخدمة</p>
          </div>
          <div className="grid grid-cols-3 gap-2">
            <div className="flex flex-col">
              <div className="w-full z-20 ">
                <Listbox
                  as="div"
                  className="space-y-1"
                  value={selectedDeviceType}
                  onChange={setSelectedDeviceType}
                >
                  {({ open }) => (
                    <>
                      <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                        نوع الجهاز
                      </Listbox.Label>
                      <div className="relative">
                        <span className="inline-block w-full rounded-md shadow-sm">
                          <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                            <span className="block truncate">
                              {selectedDeviceType?.name}
                            </span>
                            <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                              <svg
                                className="h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="none"
                                stroke="currentColor"
                              >
                                <path
                                  d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </Listbox.Button>
                        </span>

                        <Transition
                          show={open}
                          leave="transition ease-in duration-100"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                          className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                        >
                          <Listbox.Options
                            static
                            className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5 "
                          >
                            {deviceTypes.map((person) => (
                              <Listbox.Option key={person.name} value={person}>
                                {({ selected, active }) => (
                                  <div
                                    className={`${
                                      active
                                        ? "text-white bg-blue-600"
                                        : "text-gray-900"
                                    } cursor-default select-none relative py-2 pl-8 pr-4`}
                                  >
                                    <span
                                      className={`${
                                        selected
                                          ? "font-semibold"
                                          : "font-normal"
                                      } block truncate`}
                                    >
                                      {person.name}
                                    </span>
                                    {selected && (
                                      <span
                                        className={`${
                                          active
                                            ? "text-white"
                                            : "text-blue-600"
                                        } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                      >
                                        <svg
                                          className="h-5 w-5"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition>
                      </div>
                    </>
                  )}
                </Listbox>
              </div>
              <p className=" opacity-50 text-s">
                {errors?.cf_nw_rmzAljhaz?.name?.message}
              </p>
            </div>

            <div className="flex ">
              <div className="w-full z-20 ">
                <Listbox
                  as="div"
                  className="space-y-1"
                  value={selectedDeviceCode}
                  onChange={setSelectedDeviceCode}
                >
                  {({ open }) => (
                    <>
                      <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                        اسم الجهاز
                      </Listbox.Label>
                      <div className="relative">
                        <span className="inline-block w-full rounded-md shadow-sm">
                          <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                            <span className="block truncate">
                              {selectedDeviceCode?.description}
                            </span>
                            <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                              <svg
                                className="h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="none"
                                stroke="currentColor"
                              >
                                <path
                                  d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </Listbox.Button>
                        </span>

                        <Transition
                          show={open}
                          leave="transition ease-in duration-100"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                          className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                        >
                          <Listbox.Options
                            static
                            className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5 "
                          >
                            {deviceCodesx.map((person) => (
                              <Listbox.Option key={person.name} value={person}>
                                {({ selected, active }) => (
                                  <div
                                    className={`${
                                      active
                                        ? "text-white bg-blue-600"
                                        : "text-gray-900"
                                    } cursor-default select-none relative py-2 pl-8 pr-4`}
                                  >
                                    <span
                                      className={`${
                                        selected
                                          ? "font-semibold"
                                          : "font-normal"
                                      } block truncate`}
                                    >
                                      {person.description}
                                    </span>
                                    {selected && (
                                      <span
                                        className={`${
                                          active
                                            ? "text-white"
                                            : "text-blue-600"
                                        } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                      >
                                        <svg
                                          className="h-5 w-5"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition>
                      </div>
                    </>
                  )}
                </Listbox>
                <p className=" opacity-50 text-s">
                  {errors?.cf_nw_rmzAljhaz?.message}
                </p>
              </div>
            </div>
            <div className="flex ">
              <div className="w-full z-10 ">
                <Listbox
                  as="div"
                  className="space-y-1"
                  value={selectedDeviceCode}
                  onChange={setSelectedDeviceCode}
                >
                  {({ open }) => (
                    <>
                      <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                        رمز الجهاز
                      </Listbox.Label>
                      <div className="relative">
                        <span className="inline-block w-full rounded-md shadow-sm">
                          <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                            <span className="block truncate">
                              {selectedDeviceCode?.name}
                            </span>
                            <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                              <svg
                                className="h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="none"
                                stroke="currentColor"
                              >
                                <path
                                  d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </Listbox.Button>
                        </span>

                        <Transition
                          show={open}
                          leave="transition ease-in duration-100"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                          className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                        >
                          <Listbox.Options
                            static
                            className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5 "
                          >
                            {deviceCodesx.map((person) => (
                              <Listbox.Option key={person.name} value={person}>
                                {({ selected, active }) => (
                                  <div
                                    className={`${
                                      active
                                        ? "text-white bg-blue-600"
                                        : "text-gray-900"
                                    } cursor-default select-none relative py-2 pl-8 pr-4`}
                                  >
                                    <span
                                      className={`${
                                        selected
                                          ? "font-semibold"
                                          : "font-normal"
                                      } block truncate`}
                                    >
                                      {person.name}
                                    </span>
                                    {selected && (
                                      <span
                                        className={`${
                                          active
                                            ? "text-white"
                                            : "text-blue-600"
                                        } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                      >
                                        <svg
                                          className="h-5 w-5"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition>
                      </div>
                    </>
                  )}
                </Listbox>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-44">
            <div className="flex  ">
              <div className="w-full  ">
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">الكمية</span>
                  </label>
                  <input
                    name="quantity"
                    {...register("quantity")}
                    type="quantity"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.quantity?.message}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-44">
            <div className="flex ">
              <div className="w-full  z-10">
                <Listbox
                  as="div"
                  className="space-y-1"
                  value={selectedTechnical}
                  onChange={setSelectedTechnical}
                >
                  {({ open }) => (
                    <>
                      <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                        الفني المفضل
                      </Listbox.Label>
                      <div className="relative">
                        <span className="inline-block w-full rounded-md shadow-sm">
                          <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                            <span className="block truncate">
                              {selectedTechnical.name}
                            </span>
                            <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                              <svg
                                className="h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="none"
                                stroke="currentColor"
                              >
                                <path
                                  d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </Listbox.Button>
                        </span>

                        <Transition
                          show={open}
                          leave="transition ease-in duration-100"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                          className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                        >
                          <Listbox.Options
                            static
                            className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                          >
                            {technicals?.map((person) => (
                              <Listbox.Option key={person.name} value={person}>
                                {({ selected, active }) => (
                                  <div
                                    className={`${
                                      active
                                        ? "text-white bg-blue-600"
                                        : "text-gray-900"
                                    } cursor-default select-none relative py-2 pl-8 pr-4`}
                                  >
                                    <span
                                      className={`${
                                        selected
                                          ? "font-semibold"
                                          : "font-normal"
                                      } block truncate`}
                                    >
                                      {person.name}
                                    </span>
                                    {selected && (
                                      <span
                                        className={`${
                                          active
                                            ? "text-white"
                                            : "text-blue-600"
                                        } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                      >
                                        <svg
                                          className="h-5 w-5"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition>
                      </div>
                    </>
                  )}
                </Listbox>
              </div>
            </div>{" "}
            <div className="flex  ">
              <div className="w-full  z-5">
                <Listbox
                  as="div"
                  className="space-y-1"
                  value={selectedCf_nw_alwasf}
                  onChange={setSelectedCf_nw_alwasf}
                >
                  {({ open }) => (
                    <>
                      <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                        الوصف
                      </Listbox.Label>
                      <div className="relative">
                        <span className="inline-block w-full rounded-md shadow-sm">
                          <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                            <span className="block truncate">
                              {selectedCf_nw_alwasf}
                            </span>
                            <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                              <svg
                                className="h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="none"
                                stroke="currentColor"
                              >
                                <path
                                  d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </Listbox.Button>
                        </span>

                        {/* <Transition
                          show={open}
                          leave='transition ease-in duration-100'
                          leaveFrom='opacity-100'
                          leaveTo='opacity-0'
                          className='absolute mt-1 w-full rounded-md bg-white shadow-lg'
                        >
                          <Listbox.Options
                            static
                            className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5'
                          >
                            {cf_nw_alwasfs.map((person) => (
                              <Listbox.Option key={person} value={person}>
                                {({ selected, active }) => (
                                  <div
                                    className={`${
                                      active
                                        ? 'text-white bg-blue-600'
                                        : 'text-gray-900'
                                    } cursor-default select-none relative py-2 pl-8 pr-4`}
                                  >
                                    <span
                                      className={`${
                                        selected
                                          ? 'font-semibold'
                                          : 'font-normal'
                                      } block truncate`}
                                    >
                                      {person}
                                    </span>
                                    {selected && (
                                      <span
                                        className={`${
                                          active
                                            ? 'text-white'
                                            : 'text-blue-600'
                                        } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                      >
                                        <svg
                                          className='h-5 w-5'
                                          xmlns='http://www.w3.org/2000/svg'
                                          viewBox='0 0 20 20'
                                          fill='currentColor'
                                        >
                                          <path
                                            fillRule='evenodd'
                                            d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                            clipRule='evenodd'
                                          />
                                        </svg>
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition> */}
                      </div>
                    </>
                  )}
                </Listbox>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-44 ">
            <div className="col-span-2">
              <label htmlFor="" className=" text-title-100 text-md block pb-4">
                <span className="text-title-100 text-xl ">ملاحظات</span>
              </label>
              <textarea
                rows="4"
                className="block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
                placeholder="ملاحظات"
                name="notes"
                {...register("notes")}
              ></textarea>
              <p className=" opacity-50 text-s">{errors?.notes?.message}</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-44">
            <div className="col-span-2">
              <label htmlFor="" className=" text-title-100 text-md block ">
                <span className="px-1 ">ملاحظات 2</span>
              </label>
              <textarea
                rows="4"
                className="block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
                placeholder=""
                name="notes2"
                {...register("notes2")}
              ></textarea>
              <p className=" opacity-50 text-s">{errors?.notes2?.message}</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-44">
            <div className="col-span-2">
              <label htmlFor="" className=" text-title-100 text-md block ">
                <span className="px-1 ">ملاحظات 3</span>
              </label>
              <textarea
                rows="4"
                className="block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
                placeholder=""
                name="notes3"
                {...register("notes3")}
              ></textarea>
              <p className=" opacity-50 text-s">{errors?.notes3?.message}</p>
            </div>
          </div>
          <div className="flex flex-row justify-end" dir="ltr">
            <Switch
              checked={open}
              onChange={setOpen}
              className={`${
                open ? "bg-blue-600" : "bg-gray-200"
              } relative inline-flex h-6 w-11 items-center rounded-full`}
            >
              <span className="sr-only">Enable notifications</span>
              <span
                className={`${
                  open ? "translate-x-6" : "translate-x-1"
                } inline-block h-4 w-4 transform rounded-full bg-white`}
              />
            </Switch>
            <p className="pl-4">ارسال رقم الفني للزبون</p>
          </div>
          <div className="flex flex-row justify-end" dir="ltr">
            <Switch
              checked={openCustomer}
              onChange={setOpenCustomer}
              className={`${
                openCustomer ? "bg-blue-600" : "bg-gray-200"
              } relative inline-flex h-6 w-11 items-center rounded-full`}
            >
              <span className="sr-only">Enable notifications</span>
              <span
                className={`${
                  openCustomer ? "translate-x-6" : "translate-x-1"
                } inline-block h-4 w-4 transform rounded-full bg-white`}
              />
            </Switch>
            <p className="pl-4">ارسال رقم الزبون للفني </p>
          </div>
        </div>
        <div className="pt-12 justify-center flex">
          <button
            type="submit"
            className="text-white bg-button-100    font-medium  text-sm px-10 py-2.5 mr-2 mb-2    "
            disabled={disableSubmit}
          >
            تأكيد
          </button>
          <button
            type="button"
            onClick={() => navigate(`/${phoneNumber}`)}
            className="text-white bg-button-200    font-medium  text-sm px-10 py-2.5 mr-2 mb-2    "
          >
            الغاء
          </button>
        </div>
      </form>
      <Toaster position="bottom-left" reverseOrder={false} />
    </div>
  );
};

export default ServiceRequestFormScreen;
